import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./ResetPassword.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import AdultLogoDark from "../../../assets/images/dark-logo.png";
import axiosInstance from "../../../axios";
import { notify } from "../../../util/helpers";

const ResetPassword = () => {
  const { user } = useSelector((state) => state.app);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      email: e.target.email.value,
    };
    axiosInstance
      .post("/auth/password-reset/", JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          notify("Reset Password Email Sent", "success");
        }
      })
      .catch((err) => {
        notify("Something went wrong", "error");
      });
  };
  useEffect(() => {
    //*Throw the user to post-login screen if user state is not null.
    if (user) {
      navigate("/dashboard/");
    }
  }, [user]);
  return (
    <section id="resetPassword" className="resetBG">
      <CardLayout
        className="col-sm-12 col-md-3 col-lg-3"
        style={{
          margin: "auto",
          position: "absolute",
          top: "25%",
          left: "40%",
        }}
      >
        <div className="text-center">
          <img
            className="pt-3"
            src={AdultLogoDark}
            height="45%"
            width="45%"
            alt="Rose Health"
          />
          <div className="container py-4 mt-3">
            <h5 className="primary-text">Reset Password</h5>
            <span className="secondary-text">
              Enter your email to reset your password
            </span>
          </div>
        </div>
        <form onSubmit={handleSubmit} action="post" className="container-fluid">
          <div className="form-group mb-4">
            <label>Email Address</label>
            <input placeholder="Enter email address" name="email" />
          </div>
          <button
            type="submit"
            className="primary-btn mb-3"
            style={{ width: "100%" }}
          >
            Reset Password
          </button>
        </form>
        <span className="mx-auto mb-4">
          Back to <a href="/login">homepage</a>
        </span>
      </CardLayout>
    </section>
  );
};

export default ResetPassword;
